<template>
  <div class="GlobalGoals">
    <ul class="GlobalGoals__items">
      <li v-for="goal in goals" :key="goal">
        <img :src="`/images/globalgoals/Goal-${goal}.svg`" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'GlobalGoals',
  data() {
    return {
      // if increased to 3+ add slider like PlatformSlider
      goals: [
        7, 12
      ]
    }
  }
}
</script>

<style lang="scss">
  .GlobalGoals {
    position: absolute;
    bottom: 30px;
    width: 100%;
    display: flex;
    justify-content: flex-end;

    &__items {
      list-style: none;
      padding: 0;
      display: flex;
      user-select: none;
      

      li {
        padding: 0;
        margin: 0;
        margin-right: 24px;
        box-shadow: 0 0.125rem 0.8125rem rgba(0, 0, 0, 0.28);

        img {
          display: block;
          height: 94px;
          margin: 0;
          padding: 0;
        }
      }
    }

  }
</style>
